const countryOptions = [
    { value: 'France', label: 'France' },
    { value: 'UK', label: 'UK' },
    { value: 'USA', label: 'USA' },
    { value: 'Luxembourg', label: 'Luxembourg' }
  ]

  const languageOptions = [
    { value: 'French', label: 'Français' },
    { value: 'English', label: 'English' }
  ]

  const numberFormatOptions = [
    { value: '10 000,00', label: '10 000,00' },
    { value: '10 000.00', label: '10 000.00' }
  ]

  const dateFormatOptions = [
    { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
    { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' }
  ]

  const currencyOptions = [
    { value: 'Euro', label: 'Euro' },
    { value: 'Dollar', label: 'Dollar' }
  ]

  export {countryOptions, languageOptions, numberFormatOptions, dateFormatOptions, currencyOptions}